import React from "react";
import { Table, Icon } from "antd";

function CompetitorsTable(props) {
  const getTableDataSource = (competitors) => {
    return competitors.map((competitor, idx) => ({
      key: idx + 1,
      competitor: competitor,
    }));
  };

  const columns = [
    {
      dataIndex: "key",
      width: "5%",
    },
    {
      dataIndex: "competitor",
      key: "competitor",
      render: (_, record) => (
        <a href={record["competitor"]} target="_blank" rel="noopener noreferrer">
          {record["competitor"]}
        </a>
      ),
    },
    {
      dataIndex: "removeCompetitor",
      key: "removeCompetitor",
      align: "right",
      render: (_, record) => (
        <span
          className={`remove-item ${props.competitorBeingDeleted.includes(record["competitor"]) ? 'in-progress' : ''}`}
          onClick={(_) => {
            let updatedCompetitorsSetting = {
              competitors: props.competitors.filter(
                (competitor) =>
                  competitor !== record["competitor"] && !props.competitorBeingDeleted.includes(competitor)
              ),
            };

            props.updateCompetitors(
              props.domain,
              updatedCompetitorsSetting,
              `removeCompetitor_${record["competitor"]}`
            );
          }}>
          {props.competitorBeingDeleted.includes(record["competitor"]) ? (
            <Icon type="loading" />
          ) : (
            <Icon type="delete" />
          )}        
        </span>
      ),
    },
  ];
  return (
    <Table className="custom-scrollbar" columns={columns} dataSource={getTableDataSource(props.competitors)} showHeader={false} pagination={false} />
  );
}

export default CompetitorsTable;
